module.exports = __webpack_public_path__ + "./docs/img/icon-protocol.e3f3ad67fed54cc9f6fe3e32bf54b0fe.svg";